module.exports = __webpack_public_path__ + "img/left_image.6b71a411.png";